
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-studies/[post]",
      function () {
        return require("private-next-pages/case-studies/[post].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/case-studies/[post]"])
      });
    }
  